import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { TranslateModule } from "@ngx-translate/core";
import { SaleTripService } from "./sale-trip/sale-trip.service";
import { StateService } from "../../services/state.service";
import {
  CardButtonBackground,
  CardButtonSize,
} from "../../components/ui-components/buttons/card-button/card-button.model";
import { CardButtonComponent } from "src/app/components/ui-components/buttons/card-button/card-button.component";
import { SharedModule } from "src/app/shared.module";
import { SALE_ROLES } from "src/app/guards/authorization-policy";

@Component({
  selector: "app-sale",
  templateUrl: "./sale.component.html",
  styleUrls: ["./sale.component.scss"],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    CardButtonComponent,
    SharedModule
],
  standalone: true,
})
export class SaleComponent {
  private _router = inject(Router);
  private saleTripService = inject(SaleTripService);
  private state = inject(StateService);

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;
  readonly saleRoles = SALE_ROLES;

  ngOnInit() {
    this.checkWaitingTrip();
  }

  searchTrip(bnr?: string) {
    this.saleTripService.searchTrip(bnr);
  }

  goToSaleFlyTicket() {
    this._router.navigate(["fly-ticket"]);
  }

  goToETravelTicket() {
    this._router.navigate(["e-travel"]);
  }

  goToSaleVoucher() {
    this._router.navigate(["voucher"]);
  }

  private async checkWaitingTrip() {
    const waitingTrip = this.state.waitingTripId();
    if (waitingTrip !== null) {
      this.state.waitingTripId.set(null);
      this.searchTrip(waitingTrip);
    }
  }
}
